/**
 * @generated SignedSource<<fdd8e837063ff085623ea7840c342041>>
 * @relayHash 757ba3cccb4739e86a0515795ebe3a85
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 757ba3cccb4739e86a0515795ebe3a85

import { ConcreteRequest } from 'relay-runtime';
export type ProcessedStatus = "FAILED" | "ONGOING" | "SUCCEEDED";
export type ImportAtossFileInput = {
  file: any;
};
export type useImportAtossFileMutation$variables = {
  input: ImportAtossFileInput;
};
export type useImportAtossFileMutation$data = {
  readonly importAtossFile: {
    readonly atossFileUpload: {
      readonly fileHash: string | null;
      readonly id: string;
      readonly processedError: string | null;
      readonly processedStatus: ProcessedStatus | null;
      readonly uploadedAt: string | null;
      readonly uploadedBy: string | null;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type useImportAtossFileMutation = {
  response: useImportAtossFileMutation$data;
  variables: useImportAtossFileMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "AtossFileUpload",
  "kind": "LinkedField",
  "name": "atossFileUpload",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uploadedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uploadedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileHash",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "processedStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "processedError",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useImportAtossFileMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ImportAtossFilePayload",
        "kind": "LinkedField",
        "name": "importAtossFile",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useImportAtossFileMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ImportAtossFilePayload",
        "kind": "LinkedField",
        "name": "importAtossFile",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "757ba3cccb4739e86a0515795ebe3a85",
    "metadata": {},
    "name": "useImportAtossFileMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "f3febaebaa56e2428454dc8a6d6b3148";

export default node;
